module.exports = __webpack_public_path__ + "img/logo-footer.69e5151.svg";